class HPricingRange extends HTMLElement {
  constructor() {
    super()
    this.RANGE_GAP = 10
    this.debounce
    this.coinFormat = (amount) => {
      return new Intl
        .NumberFormat('es-CL', {
          style: 'currency',
          currency: 'CLP'
        })
        .format(amount)
    }
    this.attrs = HElement.GetAttributes(this)

    this.innerHTML = `
      <style>
        .h-pricing-range__wrap {
          --size: 8px;
      
          display: grid;
          grid-template-rows: -webkit-max-content var(--size);
          grid-template-rows: max-content var(--size);
          position: relative;
          margin: var(--size) auto;
          width: 95%;
          background: linear-gradient(0deg, rgb(var(--color-marca-light-grey)) var(--size), transparent 0);
          border-radius: var(--size);
        }
      
        h-pricing-range input[type=range] {
          grid-column: 1;
          grid-row: 2;
          margin: 0;
          background: none;
          /* get rid of white Chrome background */
          color: rgb(var(--color-marca-oscuro3));
          font: inherit;
          /* fix too small font-size in both Chrome & Firefox */
          pointer-events: none;
        }
        h-pricing-range input[type=range]:last-of-type {
          color: rgb(var(--color-marca-oscuro));
        }
        h-pricing-range input[type=range]::-webkit-slider-runnable-track, input[type=range]::-webkit-slider-thumb, input[type=range] {
          -webkit-appearance: none;
        }
        h-pricing-range input[type=range]::-webkit-slider-runnable-track {
          width: 100%;
          height: 100%;
          background: none;
        }
        h-pricing-range input[type=range]::-moz-range-track {
          width: 100%;
          height: 100%;
          background: none;
        }
        h-pricing-range input[type=range]::-webkit-slider-thumb {
          border: none;
          /* get rid of Firefox thumb border */
          width: var(--size);
          height: var(--size);
          border-radius: 50%;
          /* get rid of Firefox corner rounding */
          background: currentcolor;
          pointer-events: auto;
          transform: scale(2);
        }
        h-pricing-range input[type=range]::-moz-range-thumb {
          border: none;
          /* get rid of Firefox thumb border */
          width: var(--size);
          height: var(--size);
          border-radius: 50%;
          /* get rid of Firefox corner rounding */
          background: currentcolor;
          pointer-events: auto;
          transform: scale(2);
        }
        .h-pricing-range--feedback {
          display: flex;
          width: 100%;
          margin: 1em 0;
          justify-content: space-between;
          font-size: .8em;
        }
      
        .facets__price.facets__price {
          display: none;
        }
        .facets__selected.facets__selected {
          display: none;
        }
        .facets__header-vertical.facets__header-vertical {
          display: none;
        }
      </style>
      <div class="h-pricing-range--feedback">
        <span id="h-feedback-from"></span>
        <span id="h-feedback-to"></span>
      </div>
      <div class="h-pricing-range__wrap">
        <input
          type="range"
          min="0"
          max="100"
          data-max="{{ max }}"
          value="0"
          data-value="${this.attrs["data-min"]}"
          id="h-pricing-from"
        >
        <input
          type="hidden"
          name="filter.v.price.gte"
        >
        <input
          type="range"
          min="0"
          max="100"
          data-max="{{ max }}"
          data-value="${this.attrs['data-input-value']}"
          value="100"
          id="h-pricing-to"
        >
        <input
          type="hidden"
          name="filter.v.price.lte"
        >
      </div>
    `
    
    this.inputFrom = this.querySelector('#h-pricing-from')
    this.inputTo = this.querySelector('#h-pricing-to')
    this.feedbackFrom = this.querySelector('#h-feedback-from')
    this.feedbackTo = this.querySelector('#h-feedback-to')
    this.parent = this.closest('h-greenglass-filters')
    
    this.fromName = "filter.v.price.gte"
    this.toName = "filter.v.price.lte"

    this.valueFrom = this.querySelector(`[name="filter.v.price.gte"]`)
    this.valueTo = this.querySelector(`[name="filter.v.price.lte"]`)

    this.from = 0
    this.to = 100
    this.max = Number(this.dataset.max)

    this.setDefaultValues()

    this.inputFrom.addEventListener('input', (e) => {
      e.preventDefault()
      e.stopPropagation()
      this.changeFrom(e.target.value)
    })
    this.inputTo.addEventListener('input', (e) => {
      e.preventDefault()
      e.stopPropagation()
      this.changeTo(e.target.value)
    })
  }
  connectedCallback() {
    if(!this.isConnected) return
    this.parent = document.querySelector('h-greenglass-filters')
  }
  changeFrom(value, update = true) {
    const fromMax = 100 - this.RANGE_GAP
    this.from = Number(value)
    if (this.from > fromMax) {
      this.from = fromMax
      this.inputFrom.value = this.from
    }
    this.fromValue = this.toMoney(this.from)
    this.feedback()

    if (!update) {
      this.inputFrom.value = this.from
      return
    }

    if (this.from > this.to) this.changeTo(this.from + this.RANGE_GAP, false)

    this.update()
  }
  changeTo(value, update = true) {
    this.to = Number(value)
    if (this.to < this.RANGE_GAP) {
      this.to = this.RANGE_GAP
      this.inputTo.value = this.to
    }
    this.toValue = this.toMoney(this.to)
    this.feedback()

    if (!update) {
      this.inputTo.value = this.to
      return
    }
    if (this.to < this.from) this.changeFrom(this.to - this.RANGE_GAP, false)

    this.update()
  }

  setDefaultValues() {
    this.fromValue = Number(this.inputFrom.dataset.value)
    this.toValue = Number(this.inputTo.dataset.value)

    this.from = this.toRange(this.fromValue)
    this.to = this.toRange(this.toValue)

    this.inputFrom.value = this.from
    this.inputTo.value = this.to
    this.feedback()
  }

  toMoney(value) {
    return Math.round(value * this.max / 100)
  }
  toRange(value) {
    return Math.round(value * 100 / this.max)
  }

  update() {
    if (this.debounce) clearTimeout(this.debounce)
    this.valueFrom.value = this.fromValue
    this.valueTo.value = this.toValue
    this.parent.rangeApplied = {
      [this.fromName]: this.fromValue,
      [this.toName]: this.toValue
    }
  }

  feedback() {
    if (this.feedbackFrom) this.feedbackFrom.textContent = this.coinFormat(this.fromValue)
    if (this.feedbackTo) this.feedbackTo.textContent = this.coinFormat(this.toValue)
  }
}

customElements.define('h-pricing-range', HPricingRange)